import React, { ReactNode } from "react";
import { TouchableOpacity } from "react-native";
import { PaddingProps } from "@sloth-system/props";

import Box from "../Box";
import Typography from "../Typography";
import Stack from "../Stack";
import Spacer from "../Spacer";
import CircleCheckmark from "../CircleCheckmark";

interface PropsType extends PaddingProps {
  title: ReactNode | string
  sub?: string | ReactNode;
  desc?: string;
  onPress?: (...args: any) => void;
  // Types
  disabled?: boolean;
  selected?: boolean;
  readonly?: boolean;
  baseColor?: string;
}

function SelectableCard(props: PropsType) {
  let {
    selected,
    disabled,
    readonly,
    title,
    sub,
    desc,
    onPress,
    baseColor = "primary",
    ...spaceProps
  } = props;

  let cardBg = disabled ? "common.white" : `${baseColor}.light900`;
  let textColor = selected ? "green.main" : "common.black";
  let subTextColor = selected ? "green.main" : "red.main";
  let handler = disabled || readonly ? undefined : onPress;


  return (
    <Box
      style={{ width: "100%", opacity: disabled ? 0.4 : 1 }}
      p="m"
      br="m"
      bg={cardBg}
      {...spaceProps}
      // @ts-ignore
      onPress={handler}
      as={TouchableOpacity}
    >
      <Stack distribution="space-between">
        <Stack>
          {!readonly && (
            <>
              <CircleCheckmark isSelected={selected} />
              <Spacer size="m" />
            </>
          )}
          <Typography color={textColor}>{title}</Typography>
        </Stack>
        {sub && (
          <Typography ff="mainBold" fs="s" color={subTextColor}>
            {sub}
          </Typography>
        )}
      </Stack>
      {desc && (
        <Box pt="m">
          <Typography ff="mainBold" fs="s" alignment="center" color="text.hint">
            {desc}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default SelectableCard;
